<template>
    <section class="base-header-sec base-header-laen  laen NotPrintableArea">
        <div class="base-header__top-line laen"></div>
        <div class="container-fluid">

            <div class=" container-lg  base-header__container ">
                <div class="inner ml-lg-5 d-lg-flex justify-content-between align-items-center">
                    <h2 class="base-header__title mob d-block d-lg-none">
                        ПРОПИСИ ГРАДА БЕОГРАДА
                    </h2>
                    <ul class="nav ">
                        <li class="nav-item ">
                            <router-link class="nav-link  " to="/regulations-overview">Садржај</router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link  " to="/regulations-search">Претрага</router-link>

                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/regulations-static', query: { page: 'help' ,code:'REGULATIONS'}}">
                                Помоћ
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/regulations-static', query: { page: 'contact' ,code:'REGULATIONS'}}">
                                Контакт
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/regulations-static', query: { page: 'impresum' ,code:'REGULATIONS'}}">
                                Импресум
                            </router-link>
                        </li>
                    </ul>
                    <h1 class="base-header__title d-none d-lg-block">
                        ПРОПИСИ ГРАДА БЕОГРАДА
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "RegulationsBaseHeaderSec"
    }
</script>

<style scoped>

</style>
